import React from 'react';
import { Outlet } from 'react-router-dom';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';
import Header from './Header';

const StyledContainer = styled(Container)(({ theme }) => ({
	display: 'flex',
	direction: 'column',
	width: '100%',
	marginTop: '20px',
	overflow: 'hidden',
	justifyContent: 'center'
}));

const Layout = () => {
	return (
		<React.Fragment>
			<Header />
			<StyledContainer>
				<Stack width='800px' direction='column'>
					<Outlet />
				</Stack>
			</StyledContainer>
		</React.Fragment>
	);
};

export default Layout;
